import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";

import { referencesAjax } from "../../ajax/ReferencesAjax";
import { ErrorResponse } from "../../DTOs/Common/ErrorResponse";
import { MapFeatureDTO } from "../../DTOs/Production/MapFeatureDTO";
import { MapFeature, toMapFeatures } from "./mapFeatures";

export const MAP_FEATURE_QUERY_KEY = ["references", "mapFeatures"];

export function useMapFeatures(): { features: MapFeature[]; isSettled: boolean } {
  const { data = [], isPending } = useQuery({
    queryKey: MAP_FEATURE_QUERY_KEY,
    queryFn: async () => {
      const res = await referencesAjax.getMapFeatures();
      if (ErrorResponse.isErrorResponse(res) || !res.data) return [] as MapFeatureDTO[];
      return res.data;
    },
    staleTime: 5 * 60 * 1000,
  });

  const features = useMemo(() => toMapFeatures(data), [data]);

  return { features, isSettled: !isPending };
}
